import { Component, Renderer2, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-aidriven-insuranceapp',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './aidriven-insuranceapp.component.html',
  styleUrl: './aidriven-insuranceapp.component.scss'
})
export class AidrivenInsuranceappComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  nav(url: any) {
    console.log(url);
    this.router.navigateByUrl(url)
  }
  injectSchemaMarkup(): void {
    const insuranceCaseStudySchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/aidriven-insurance-application",
          "url": "https://www.kalpitatechnologies.com/kalpita-case-studies/aidriven-insurance-application",
          "name": "AI-Driven Insurance Application Accelerator: Customer Onboarding Platform – Case Study",
          "description": "Case study on how Kalpita Technologies developed an AI-driven insurance application accelerator that automates questionnaires and reduces manual efforts by 70%.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2025-01-28"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/aidriven-insurance-application#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/case-study", "name": "Case Studies" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/aidriven-insurance-application", "name": "AI Insurance Accelerator" } }
          ]
        },
        {
          "@type": "Article",
          "headline": "AI-Driven Insurance Application Accelerator: Customer Onboarding Platform",
          "articleBody": "Kalpita Technologies developed an AI-Driven Insurance Application Accelerator as a customer onboarding platform for a health and life insurance provider...",
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-01-28",
          "image": "https://www.kalpitatechnologies.com/assets/resources/casestudies/aidriven-insurance/aiclient-profile.webp"
        },
        {
          "@type": "HowTo",
          "name": "How to Build an AI-Driven Insurance Customer Onboarding Platform",
          "step": [
            { "@type": "HowToStep", "name": "Assess Pain Points", "text": "Identify inefficiencies in existing manual insurance application processes." },
            { "@type": "HowToStep", "name": "Automate Questionnaires", "text": "Build AI-driven automation that completes customized questionnaires." },
            { "@type": "HowToStep", "name": "Centralize Evaluation", "text": "Implement an AI-powered centralized evaluation layer." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/aidriven-insurance-application#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What results did the platform achieve?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The platform achieved a 50% reduction in processing time, 70% decrease in manual intervention, and 99.9% system uptime."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(insuranceCaseStudySchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
}
